module.exports = __webpack_public_path__ + "Badge_TranquilTeachings-eb3991c5fec91255e76c117be6911ace.svg";